import React, {Component} from 'react'

class IconGoogle extends Component{
    render(){
        const styles = {
            fill: this.props.color,
            width: this.props.width,
            height: this.props.height
        }
        return (
            <svg xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                x="0px" y="0px" 
                viewBox="0 0 491.858 491.858"
                style={styles}
                >
                <style>
                    { `enable-background:new 0 0 491.858 491.858;`}
                </style>
                <path d="M377.472,224.957H201.319v58.718H308.79c-16.032,51.048-63.714,88.077-120.055,88.077
                    c-69.492,0-125.823-56.335-125.823-125.824c0-69.492,56.333-125.823,125.823-125.823c34.994,0,66.645,14.289,89.452,37.346
                    l42.622-46.328c-34.04-33.355-80.65-53.929-132.074-53.929C84.5,57.193,0,141.693,0,245.928s84.5,188.737,188.736,188.737
                    c91.307,0,171.248-64.844,188.737-150.989v-58.718L377.472,224.957L377.472,224.957z"/>
                <polygon points="491.858,224.857 455.827,224.857 455.827,188.826 424.941,188.826 424.941,224.857 388.91,224.857 
                    388.91,255.74 424.941,255.74 424.941,291.772 455.827,291.772 455.827,255.74 491.858,255.74"/>
            </svg>
        )
    }
} 

export default IconGoogle